const DEFAULT_SMOOTHING_FACTOR = 0.7;

/**
 * Calculates the current audio level based on buffer changes with smoothing.
 * @param newBuffer New audio buffer
 * @param prevValue The previous value of audio level
 * @param smoothingFactor Defines the weight of prevValue in the calculations. From 0 to 1.
 * @returns {number} new audio level
 */
export const calculateAudioLevel = (
  newBuffer: Float32Array,
  prevValue = 0,
  smoothingFactor: number = DEFAULT_SMOOTHING_FACTOR,
): number => {
  if (newBuffer[0] === undefined) {
    return prevValue;
  }

  let squaredSum = 0;

  for (const element of newBuffer) {
    squaredSum += element * element;
  }

  const rms = Math.sqrt(squaredSum / newBuffer.length);
  const scaledValue = Math.round(rms * 1000);
  const clampedValue = Math.min(100, Math.max(0, scaledValue));

  const smoothedPreValue = prevValue * smoothingFactor;
  const smoothedNewValue = clampedValue * (1 - smoothingFactor);
  const value = smoothedPreValue + smoothedNewValue;

  return value;
};
